import { useIntl } from 'react-intl';
import { forwardRef } from '@chakra-ui/react';

import { Table } from '../../Table';
import { type RowProps } from '../../Table/parts';
import { useFees } from '../context';

export type OtherCertificateProsp = RowProps;

export const OtherCertificate = forwardRef<OtherCertificateProsp, 'div'>(
  (props, ref) => {
    const intl = useIntl();
    const { fees, toFixed, toVariable } = useFees();

    const locales = {
      label: intl.formatMessage({
        id: 'subscription.fees_modal.other_certificate.label',
      }),
      value: intl.formatMessage(
        {
          id: 'subscription.fees_modal.other_certificate.value',
        },
        {
          fixed: toFixed(fees.otherCertificate),
          variable: toVariable(fees.otherCertificate),
        },
      ),
    };

    return (
      <Table.Row {...props} ref={ref}>
        <Table.CellText>{locales.label}</Table.CellText>
        <Table.CellAmount>{locales.value}</Table.CellAmount>
      </Table.Row>
    );
  },
);
